import React from 'react';
import styled from 'styled-components';
import logo from '../../../assets/logoWhite/sunbit-logo.png';
import logo2x from '../../../assets/logoWhite/sunbit-logo@2x.png';
import logo3x from '../../../assets/logoWhite/sunbit-logo@3x.png';
import facebook from '../../../assets/facebook.png';
import twitter from '../../../assets/twitter.png';
import linkedin from '../../../assets/linkedin.png';
import instagram from '../../../assets/instagram.png';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

// tslint:disable-next-line:variable-name
const SFooterSection = styled.section(
  ({ theme }) => `
  padding-top: ${theme.spacing.huge}px;
  padding-bottom: ${theme.spacing.larger}px;
  background-color: ${theme.colors.primary};
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    padding-top: ${theme.spacing.larger}px;
    padding-bottom: ${theme.spacing.larger}px;
    padding-left: ${theme.spacing.larger}px;
    padding-right: ${theme.spacing.larger}px;
  }
  padding-left: ${theme.spacing.gargantuan}px;
  padding-right: ${theme.spacing.gargantuan}px;
  justify-content: space-between;
`
);

// tslint:disable-next-line:variable-name
const SLogoDiv = styled.div`
  margin-bottom: 25px;
`;

// tslint:disable-next-line:variable-name
const SSubmenu = styled.section(
  () => `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-width: 100px;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }

`
);

// tslint:disable-next-line:variable-name
const SSubmenuItem = styled.span(({ theme }) => ({
  color: `${theme.colors.white}`,
  fontSize: `${theme.font.size.small}`,
  marginBottom: `${theme.spacing.medium}px`,
  marginRight: '15px',
}));

// tslint:disable-next-line:variable-name
const SSubmenuItemLink = styled.a(({ theme }) => ({
  color: `${theme.colors.white}`,
  fontSize: `${theme.font.size.small}`,
  marginBottom: `${theme.spacing.medium}px`,
  textDecoration: 'none',
}));

// tslint:disable-next-line:variable-name
const SMenu = styled.div`
@media only screen and (max-width: 1000px) {
  margin-bottom: 25px;
  display: flex,
  flex-direction: row,
  justify-ontent: space-between,
  align-items: flex-start
}`;

// tslint:disable-next-line:variable-name
const SSocialSection = styled.section(
  () => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 25px;
  @media only screen and (max-width: 1000px) {
    justify-content: end;
  }

`
);

// tslint:disable-next-line:variable-name
const SSocialLink = styled.a(
  () => `
  display: contents;
`
);

// tslint:disable-next-line:variable-name
const SSocialMediaIcon = styled.div(({ theme }) => ({
  borderRadius: `${theme.borderRadiusRound}px`,
  height: '35px',
  width: '35px',
  backgroundColor: `${theme.colors.headlineGrey}`,
  marginRight: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

// tslint:disable-next-line:variable-name
const SCopyRightDiv = styled.div(({ theme }) => ({
  fontSize: `${theme.font.size.small}`,
  color: `${theme.colors.headlineGrey}`,
}));

// tslint:disable-next-line:variable-name
const Footer: React.FC<{}> = () => (
  <SFooterSection data-dd-privacy={PrivacyOptions.Allow}>
    <div>
      <SLogoDiv>
        <img
          alt="Logo"
          src={logo}
          srcSet={`${logo2x} 2x,
                 ${logo3x} 3x`}
        />
      </SLogoDiv>
      <SMenu>
        <SSubmenu>
          <SSubmenuItem>
            <SSubmenuItemLink data-at="faqLink" href="https://sunbit.com/im-a-consumer/sunbit-card-faq/" target="_blank">
              FAQs
            </SSubmenuItemLink>
          </SSubmenuItem>
          <SSubmenuItem>
            <SSubmenuItemLink data-at="websiteConsumerPrivacyLink" href="https://sunbit.com/consumer-privacy-policy.html" target="_blank">
              consumer privacy
            </SSubmenuItemLink>
          </SSubmenuItem>
          <SSubmenuItem>
            <SSubmenuItemLink data-at="websitePrivacyLink" href="https://sunbit.com/website-privacy-policy.html" target="_blank">
              website privacy
            </SSubmenuItemLink>
          </SSubmenuItem>
          <SSubmenuItem>
            <SSubmenuItemLink data-at="websiteTermsLink" href="https://sunbit.com/terms-of-use.html" target="_blank">
              terms
            </SSubmenuItemLink>
          </SSubmenuItem>
          <SSubmenuItem>
            <SSubmenuItemLink data-at="contactUsLink" href="/contact-us" target="_blank">
              contact us
            </SSubmenuItemLink>
          </SSubmenuItem>
        </SSubmenu>
      </SMenu>
    </div>
    <div>
      <SSocialSection>
        <SSocialMediaIcon>
          <SSocialLink data-at="instagramLink" href="https://www.instagram.com/sunbit_fintech/" target="_blank">
            <img src={instagram} alt="instagram logo" />
          </SSocialLink>
        </SSocialMediaIcon>
        <SSocialMediaIcon>
          <SSocialLink data-at="facebookLink" href="https://www.facebook.com/sunbitfintech/" target="_blank">
            <img src={facebook} alt="facebook logo" />
          </SSocialLink>
        </SSocialMediaIcon>
        <SSocialMediaIcon>
          <SSocialLink data-at="twitterLink" href="https://twitter.com/sunbit_fintech" target="_blank">
            <img src={twitter} alt="twitter logo" />
          </SSocialLink>
        </SSocialMediaIcon>
        <SSocialMediaIcon>
          <SSocialLink data-at="linkedinLink" href="https://www.linkedin.com/company/sunbit/" target="_blank">
            <img src={linkedin} alt="linkedin logo" />
          </SSocialLink>
        </SSocialMediaIcon>
      </SSocialSection>
      <SCopyRightDiv>© 2023 Sunbit. All Rights Reserved.</SCopyRightDiv>
    </div>
  </SFooterSection>
);

export default Footer;
